import * as rq from '@tanstack/react-query';

import type { IAlertsRepository } from '@/alerts/domain/repositories/alerts.repository';
import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';

export namespace ListAlerts {
  export const key = (input: Input) => [
    'alerts',
    'list-alerts',
    ...Object.entries(input).flatMap(([key, value]) => [key, value]),
  ];

  export type Params = { refetchInterval?: number };
  export type Input = IAlertsRepository.GetAllInput;
  export type Output = IAlertsRepository.GetAllOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () => repositories.alerts.getAll(input),
    });
  }
}
